import { usePost } from "@albertine/api-client";
import * as Sentry from "@sentry/react";
import { useHistory } from "react-router-dom";

import { EventEmitter } from "../../EventEmitter";

export function useCreateRequestFromMessages(params: {
    memberId: string;
    assignedToAgentId: string;
    onCreated?: () => void;
}) {
    const history = useHistory();
    const { mutate, isPending } = usePost("createRequest", {
        onSuccess: (result) => {
            params.onCreated?.();
            history.push(`/request/${result.id}`);
        },
        onError: (error) => {
            Sentry.captureException(error);
            EventEmitter.emit({
                name: "showToastMessage",
                params: {
                    message: "Failed to create a new request",
                    type: "error",
                },
            });
        },
    });

    function createRequestFromMessages(messageIds: string[]) {
        mutate({
            json: {
                memberId: params.memberId,
                assignedToAgentId: params.assignedToAgentId,
                createdFromMessageIds: messageIds,
            },
        });
    }

    return { createRequestFromMessages, isPending };
}
